import { registerPlugin } from '@capacitor/core'

interface AppSettingsType {
  openSettings(): Promise<void>
  getNotificationPermission(): Promise<{ value: boolean }>
}

export const AppSettings = registerPlugin<AppSettingsType>('AppSettings')
